(function () {
  if (window.KCB) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var K = (window.KCB = { mods: {}, cart: null, format: '${{amount}}', root: root, busy: 0 });

  K.$ = function (sel, scope) {
    return (scope || document).querySelector(sel);
  };

  K.$$ = function (sel, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(sel));
  };

  K.money = function (cents) {
    cents = Math.round(Number(cents) || 0);
    var match = K.format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = match ? match[1] : 'amount';
    var build = function (decimals, thousands, point) {
      var parts = (cents / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + point + parts[1] : parts[0];
    };
    var value;
    if (kind === 'amount_no_decimals') value = build(0, ',', '.');
    else if (kind === 'amount_with_comma_separator') value = build(2, '.', ',');
    else if (kind === 'amount_no_decimals_with_comma_separator') value = build(0, '.', ',');
    else if (kind === 'amount_with_apostrophe_separator') value = build(2, "'", '.');
    else if (kind === 'amount_no_decimals_with_space_separator') value = build(0, ' ', ',');
    else if (kind === 'amount_with_space_separator') value = build(2, ' ', ',');
    else value = build(2, ',', '.');
    return match ? K.format.replace(match[0], value) : value;
  };

  K.fill = function (template, values) {
    return String(template || '').replace(/\[(\w+)\]/g, function (all, key) {
      return values[key] === undefined ? all : values[key];
    });
  };

  K.json = function (el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || el.getAttribute('data-json') || 'null');
    } catch (e) {
      return null;
    }
  };

  K.register = function (name, init) {
    K.mods[name] = init;
  };

  K.init = function (scope) {
    var nodes = K.$$('[data-kcb]', scope);
    if (scope && scope.matches && scope.matches('[data-kcb]')) nodes.unshift(scope);
    nodes.forEach(function (el) {
      if (el.kcbReady) return;
      var init = K.mods[el.getAttribute('data-kcb')];
      if (!init) return;
      el.kcbReady = true;
      init(el, K);
    });
  };

  K.on = function (name, handler) {
    document.addEventListener('kcb:' + name, function (event) {
      handler(event.detail || {}, event);
    });
  };

  K.emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent('kcb:' + name, { detail: detail || {} }));
  };

  K.toast = function (message, isError) {
    var node = K.toastNode;
    if (!node) {
      node = document.createElement('div');
      node.className = 'kcb kcb-toast';
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
      document.body.appendChild(node);
      K.toastNode = node;
    }
    node.lastChild.textContent = message;
    node.classList.toggle('is-error', !!isError);
    node.classList.add('is-on');
    clearTimeout(K.toastTimer);
    K.toastTimer = setTimeout(function () {
      node.classList.remove('is-on');
    }, 2600);
  };

  K.flash = function (buttons, label) {
    buttons.forEach(function (button) {
      if (button.kcbLabel === undefined) button.kcbLabel = button.textContent;
      button.classList.add('is-added');
      button.textContent = label;
      clearTimeout(button.kcbTimer);
      button.kcbTimer = setTimeout(function () {
        button.classList.remove('is-added');
        button.textContent = button.kcbLabel;
        button.kcbLabel = undefined;
      }, 1400);
    });
  };

  K.units = function (title) {
    var text = String(title || '').split('+')[0];
    if (/sample/i.test(text)) return 0;
    var match = text.match(/(\d+)\s*-?\s*(pack|pk|ct|count|unit)/i) || text.match(/^\s*(\d+)\b/);
    if (match) return parseInt(match[1], 10) || 0;
    var words = { single: 1, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, eight: 8, ten: 10, twelve: 12 };
    var word = text.toLowerCase().match(/single|one|two|three|four|five|six|eight|ten|twelve/);
    return word ? words[word[0]] : 1;
  };

  function themeCart() {
    return document.querySelector('cart-notification, cart-drawer');
  }

  function themeSections() {
    var el = themeCart();
    if (!el || typeof el.getSectionsToRender !== 'function') return [];
    try {
      return el
        .getSectionsToRender()
        .map(function (section) {
          return section.section || section.id;
        })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function toggle(node, name, state) {
    if (node && node.classList) node.classList.toggle(name, state);
  }

  function renderTheme(state) {
    var el = themeCart();
    if (!el || !state || !state.sections || typeof el.getSectionsToRender !== 'function') return;
    var parser = new DOMParser();
    try {
      el.getSectionsToRender().forEach(function (section) {
        var html = state.sections[section.section || section.id];
        if (!html) return;
        var source = parser.parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
        var target = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (source && target) target.innerHTML = source.innerHTML;
      });
      var countHtml = state.sections['cart-notification-count'];
      if (countHtml) {
        var count = parseInt(parser.parseFromString(countHtml, 'text/html').body.textContent, 10) || 0;
        var empty = count === 0;
        toggle(el.emptyCartItem, 'no-js-inline', empty);
        toggle(el.emptyCartButtonDisable, 'no-js-inline', empty);
        toggle(el.cartItemMessageShow, 'no-js-inline', !empty);
        toggle(el.cartAddSuccess, 'no-js-inline', empty);
        toggle(el.cartEmptyHead, 'no-js-inline', !empty);
      }
      el.classList.remove('is-empty');
    } catch (e) {}
  }

  function request(path, body) {
    K.busy += 1;
    return fetch(root + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body ? JSON.stringify(body) : undefined
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .finally(function () {
        K.busy -= 1;
      });
  }

  K.refresh = function () {
    return request('cart.js')
      .then(function (result) {
        if (result.ok) {
          K.cart = result.data;
          K.emit('cart', K.cart);
        }
        return K.cart;
      })
      .catch(function () {
        return K.cart;
      });
  };

  K.add = function (items, errorText) {
    var body = {
      items: items.map(function (item) {
        var line = { id: item.id, quantity: item.quantity || 1 };
        if (item.selling_plan) line.selling_plan = item.selling_plan;
        return line;
      })
    };
    var sections = themeSections();
    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }
    return request('cart/add.js', body).then(function (result) {
      if (!result.ok || result.data.status) {
        var message = result.data.description || result.data.message || errorText || '';
        if (message) K.toast(message, true);
        throw new Error(message);
      }
      renderTheme(result.data);
      return K.refresh().then(function () {
        return result.data;
      });
    });
  };

  K.openCart = function () {
    setTimeout(function () {
      var el = themeCart();
      if (el && typeof el.open === 'function') el.open();
      else window.location.href = root + 'cart';
    }, 0);
  };

  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function (input) {
      var promise = nativeFetch.apply(this, arguments);
      try {
        var url = String((input && input.url) || input || '');
        if (!K.busy && /\/cart\/(add|change|update|clear)/.test(url)) {
          promise
            .then(function () {
              setTimeout(K.refresh, 80);
            })
            .catch(function () {});
        }
      } catch (e) {}
      return promise;
    };
  }

  K.boot = function () {
    var holder = document.querySelector('[data-kcb-money]');
    if (holder) K.format = holder.getAttribute('data-kcb-money').replace(/<[^>]*>/g, '') || K.format;
    K.init(document);
    K.refresh();
  };

  document.addEventListener('shopify:section:load', function (event) {
    K.init(event.target);
  });
})();

KCB.register('buy-box', function (el, K) {
  var all = K.$$('[data-kcb-opt]', el);
  var options = all.filter(function (o) {
    return !o.disabled && o.hasAttribute('data-vid');
  });
  var thumbs = K.$$('[data-kcb-thumb]', el);
  var main = K.$('[data-kcb-main]', el);
  var cap = K.$('[data-kcb-cap]', el);
  var qtyInput = K.$('[data-kcb-qty]', el);
  var form = K.$('[data-kcb-form]', el);
  var idInput = K.$('[data-kcb-id]', el);
  var planInput = K.$('[data-kcb-plan]', el);
  var auto = K.$('[data-kcb-auto]', el);
  var autoSwitch = K.$('[data-kcb-auto-switch]', el);
  var autoOpts = K.$('[data-kcb-auto-opts]', el);
  var rcard = K.$('[data-kcb-rcard]', el);
  var packnote = K.$('[data-kcb-packnote]', el);
  var sbar = K.$('[data-kcb-sbar]', el);
  var mbar = K.$('[data-kcb-mbar]', el);
  var lightbox = K.$('[data-kcb-lightbox]', el);
  var col = K.$('[data-kcb-col]', el);
  var msrp = Number(el.getAttribute('data-msrp')) || 0;
  var state = { opt: null, pack: null, qty: 1, auto: false, planName: '', image: 0, busy: false, plansKey: '' };

  function num(node, name) {
    return Number(node.getAttribute(name)) || 0;
  }

  function plansOf(node) {
    try {
      return JSON.parse(node.getAttribute('data-plans') || '[]');
    } catch (e) {
      return [];
    }
  }

  function thumbAt(index) {
    return thumbs.filter(function (t) {
      return Number(t.getAttribute('data-kcb-thumb')) === index;
    })[0];
  }

  function showImage(index) {
    var thumb = thumbAt(index);
    if (!thumb || !main) return;
    state.image = index;
    main.src = thumb.getAttribute('data-full');
    var text = thumb.getAttribute('data-cap') || '';
    if (text) main.alt = text;
    if (cap) {
      cap.textContent = text;
      cap.hidden = !text;
    }
    thumbs.forEach(function (t) {
      t.classList.toggle('is-on', t === thumb);
    });
  }

  function currentPlan() {
    if (!state.opt || !state.auto) return null;
    var plans = plansOf(state.opt);
    if (!plans.length) return null;
    return (
      plans.filter(function (p) {
        return p.name === state.planName;
      })[0] || plans[0]
    );
  }

  function renderAuto() {
    if (!auto) return;
    var plans = state.opt ? plansOf(state.opt) : [];
    var has = plans.length > 0;
    if (!has) state.auto = false;
    auto.classList.toggle('is-off', !has);
    auto.classList.toggle('is-on', state.auto);
    autoSwitch.disabled = !has;
    autoSwitch.setAttribute('aria-checked', state.auto ? 'true' : 'false');
    var key = plans
      .map(function (p) {
        return p.id;
      })
      .join(',');
    if (key !== state.plansKey) {
      state.plansKey = key;
      autoOpts.innerHTML = '';
      plans.forEach(function (p) {
        var button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('data-kcb-plan-name', p.name);
        button.textContent = p.name;
        autoOpts.appendChild(button);
      });
    }
    var plan = currentPlan();
    K.$$('[data-kcb-plan-name]', autoOpts).forEach(function (button) {
      button.classList.toggle('is-on', !!plan && button.getAttribute('data-kcb-plan-name') === plan.name);
    });
  }

  function render() {
    renderAuto();
    var opt = state.opt;
    var plan = currentPlan();
    var name = opt ? opt.getAttribute('data-name') : '';
    var price = opt ? (plan ? plan.price : num(opt, 'data-price')) : 0;
    var total = price * state.qty;
    var suffix = plan ? ' · ' + plan.name : '';

    K.$$('[data-kcb-total]', el).forEach(function (node) {
      node.textContent = opt ? K.money(total) : '';
    });
    var label = K.$('[data-kcb-total-label]', el);
    if (label) label.textContent = opt ? state.qty + ' × ' + name + suffix : '';
    var sbarSel = K.$('[data-kcb-sbar-sel]', el);
    if (sbarSel) sbarSel.textContent = opt ? name + ' · ' + (el.getAttribute('data-qty-word') || '') + ' ' + state.qty + suffix : '';
    var mbarSel = K.$('[data-kcb-mbar-sel]', el);
    if (mbarSel) mbarSel.textContent = name;
    var sbarImg = K.$('[data-kcb-sbar-img]', el);
    var thumb = opt ? thumbAt(num(opt, 'data-img')) : null;
    if (sbarImg && thumb) sbarImg.src = K.$('img', thumb).src;

    if (idInput && opt) idInput.value = opt.getAttribute('data-vid');
    if (planInput) {
      planInput.disabled = !plan;
      planInput.value = plan ? plan.id : '';
    }

    var pack = state.pack;
    var unitNode = K.$('[data-kcb-unit-price]', el);
    if (unitNode && pack) unitNode.textContent = K.money(num(pack, 'data-unit-price'));
    if (rcard) rcard.classList.toggle('is-on', !!opt && opt.getAttribute('data-group') === 'pack');
    if (packnote) {
      packnote.hidden = !pack;
      if (pack) {
        var units = num(pack, 'data-units');
        K.$('[data-kcb-packnote-text]', packnote).textContent = K.fill(packnote.getAttribute('data-template'), { pack: pack.getAttribute('data-label'), msrp: K.money(msrp) });
        K.$('[data-kcb-packnote-value]', packnote).textContent = K.money(msrp * units);
        K.$('[data-kcb-packnote-keep]', packnote).textContent = K.money(msrp * units - num(pack, 'data-price'));
      }
    }
  }

  function select(opt, keepImage, silent) {
    if (!opt) return;
    state.opt = opt;
    if (opt.getAttribute('data-group') === 'pack') state.pack = opt;
    all.forEach(function (o) {
      o.classList.toggle('is-on', o === opt);
      o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
    });
    if (!keepImage) showImage(num(opt, 'data-img'));
    render();
    if (!silent) {
      K.emit('selected', { variant: num(opt, 'data-vid'), group: opt.getAttribute('data-group'), units: num(opt, 'data-units'), price: num(opt, 'data-price'), source: el });
    }
  }

  function byVariant(id) {
    return options.filter(function (o) {
      return String(o.getAttribute('data-vid')) === String(id);
    })[0];
  }

  function firstOf(group) {
    return options.filter(function (o) {
      return o.getAttribute('data-group') === group;
    })[0];
  }

  function setQty(value) {
    state.qty = Math.max(1, Math.min(99, parseInt(value, 10) || 1));
    if (qtyInput) qtyInput.value = state.qty;
    render();
  }

  function add() {
    if (!state.opt || state.busy) return;
    state.busy = true;
    var plan = currentPlan();
    var name = state.opt.getAttribute('data-name');
    var qty = state.qty;
    var item = { id: num(state.opt, 'data-vid'), quantity: qty };
    if (plan) item.selling_plan = plan.id;
    K.add([item], el.getAttribute('data-error'))
      .then(function () {
        K.toast(K.fill(el.getAttribute('data-toast'), { qty: qty, product: el.getAttribute('data-product-title'), name: name }) + (plan ? ' · ' + plan.name : ''));
        K.flash(K.$$('[data-kcb-add]', el), el.getAttribute('data-added-label'));
      })
      .catch(function () {})
      .then(function () {
        state.busy = false;
      });
  }

  el.addEventListener('click', function (event) {
    var target = event.target.closest('button, a');
    if (!target || !el.contains(target)) {
      if (lightbox && event.target === lightbox) lightbox.classList.remove('is-on');
      return;
    }
    if (target.hasAttribute('data-kcb-thumb')) return showImage(num(target, 'data-kcb-thumb'));
    if (target.hasAttribute('data-kcb-zoom')) {
      var thumb = thumbAt(state.image);
      if (thumb && lightbox) {
        K.$('[data-kcb-lightbox-img]', lightbox).src = thumb.getAttribute('data-full');
        lightbox.classList.add('is-on');
      }
      return;
    }
    if (target.hasAttribute('data-kcb-lightbox-close')) return lightbox.classList.remove('is-on');
    if (target.hasAttribute('data-kcb-opt')) return select(target);
    if (target.hasAttribute('data-kcb-rcard-main')) return select(state.pack || firstOf('pack'));
    if (target.hasAttribute('data-kcb-step')) return setQty(state.qty + num(target, 'data-kcb-step'));
    if (target.hasAttribute('data-kcb-auto-switch')) {
      state.auto = !state.auto;
      return render();
    }
    if (target.hasAttribute('data-kcb-plan-name')) {
      state.planName = target.getAttribute('data-kcb-plan-name');
      return render();
    }
    if (target.hasAttribute('data-kcb-add') && target.type !== 'submit') add();
  });

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      add();
    });
  }
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      setQty(qtyInput.value);
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && lightbox) lightbox.classList.remove('is-on');
  });

  K.on('select', function (detail) {
    if (detail.source === el) return;
    var opt = detail.variant ? byVariant(detail.variant) : firstOf(detail.group || 'size');
    if (!opt) return;
    if (detail.preferDefault && opt.getAttribute('data-group') === 'pack' && state.pack) opt = state.pack;
    select(opt, detail.keepImage, true);
    if (detail.scroll) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (detail.add) add();
  });

  if (sbar && col && 'IntersectionObserver' in window) {
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sbar.classList.toggle('is-on', on);
          sbar.setAttribute('aria-hidden', on ? 'false' : 'true');
          K.$$('button', sbar).forEach(function (button) {
            button.tabIndex = on ? 0 : -1;
          });
        });
      },
      { threshold: 0 }
    ).observe(col);
  }

  if (mbar && window.matchMedia) {
    var query = window.matchMedia('(max-width: 900px)');
    var pad = function () {
      document.body.style.paddingBottom = query.matches ? mbar.offsetHeight + 'px' : '';
    };
    pad();
    if (query.addEventListener) query.addEventListener('change', pad);
  }

  state.pack = byVariant(el.getAttribute('data-default-pack')) || firstOf('pack') || null;
  var initial = byVariant(el.getAttribute('data-default')) || options[0];
  if (thumbs.length) showImage(0);
  if (initial) select(initial, true, true);
  else render();
});

KCB.register('order-strip', function (el, K) {
  var holder = el.closest('.kcb-strip-section') || el.parentNode;
  var nav = K.$('[data-kcb-nav]', el);
  var links = K.$$('[data-kcb-link]', el);
  var chips = K.$('[data-kcb-chips]', el);
  var unitsNode = K.$('[data-kcb-units]', el);
  var checkout = K.$('[data-kcb-checkout]', el);
  var mbar = K.$('[data-kcb-mbar]', el);
  var mbarText = K.$('[data-kcb-mbar-text]', el);
  var offset = Number(el.getAttribute('data-offset')) || 0;
  var headerSel = el.getAttribute('data-header') || '';
  var query = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  var state = { count: 0, pinned: null, settled: false, pinTimer: 0, ticking: false, timer: 0 };

  function alive() {
    return document.body.contains(el);
  }

  function targetOf(link) {
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return null;
    return document.getElementById(href.slice(1));
  }

  function headerHeight() {
    var node = null;
    try {
      node = headerSel ? document.querySelector(headerSel) : null;
    } catch (e) {
      node = null;
    }
    while (node && node !== document.body && node !== document.documentElement) {
      var position = window.getComputedStyle(node).position;
      if (position === 'fixed' || position === 'sticky') {
        var rect = node.getBoundingClientRect();
        return rect.top <= 0 ? Math.max(0, Math.round(rect.bottom)) : 0;
      }
      node = node.parentElement;
    }
    return 0;
  }

  function place() {
    state.ticking = false;
    if (!alive()) return;
    var top = offset + headerHeight();
    holder.style.setProperty('--kcb-strip-top', top + 'px');
    document.body.style.setProperty('--kcb-scroll-offset', el.offsetHeight + top + 16 + 'px');
  }

  function settle() {
    state.settled = true;
  }

  function pin(link) {
    state.pinned = link;
    state.settled = false;
    clearTimeout(state.pinTimer);
    state.pinTimer = setTimeout(settle, 900);
    mark();
  }

  function onScroll() {
    if (state.pinned) {
      if (state.settled) {
        state.pinned = null;
        mark();
      } else {
        clearTimeout(state.pinTimer);
        state.pinTimer = setTimeout(settle, 200);
      }
    }
    queue();
  }

  function queue() {
    if (!state.ticking) {
      state.ticking = true;
      window.requestAnimationFrame(place);
    }
    clearTimeout(state.timer);
    state.timer = setTimeout(place, 320);
  }

  function pad() {
    if (!mbar || !alive()) return;
    var on = state.count > 0 && (!query || query.matches);
    document.body.style.paddingBottom = on ? mbar.offsetHeight + 'px' : '';
  }

  function mark() {
    var current = state.pinned;
    links.forEach(function (link) {
      if (!current && link.kcbSeen) current = link;
    });
    if (!current) return;
    links.forEach(function (link) {
      link.classList.toggle('is-on', link === current);
      if (link === current) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    if (nav && nav.scrollWidth > nav.clientWidth) {
      var left = current.offsetLeft - nav.offsetLeft;
      if (left < nav.scrollLeft || left + current.offsetWidth > nav.scrollLeft + nav.clientWidth) nav.scrollLeft = Math.max(0, left - 16);
    }
  }

  function render(cart) {
    if (!alive()) return;
    var items = (cart && cart.items) || [];
    var units = 0;
    var count = 0;
    items.forEach(function (item) {
      units += K.units(item.variant_title) * item.quantity;
      count += item.quantity;
    });
    state.count = count;
    if (chips) {
      chips.textContent = '';
      items.forEach(function (item) {
        var chip = document.createElement('span');
        var qty = document.createElement('b');
        var name = item.product_title || '';
        if (item.variant_title && item.variant_title !== 'Default Title') name += ' ' + item.variant_title;
        qty.textContent = item.quantity + '×';
        chip.appendChild(qty);
        chip.appendChild(document.createTextNode(name));
        chips.appendChild(chip);
      });
      if (!items.length) {
        var empty = document.createElement('em');
        empty.textContent = chips.getAttribute('data-empty') || '';
        chips.appendChild(empty);
      }
    }
    K.$$('[data-kcb-sub]', el).forEach(function (node) {
      node.textContent = K.money(cart ? cart.total_price : 0);
    });
    if (unitsNode) unitsNode.textContent = K.fill(unitsNode.getAttribute('data-template'), { units: units });
    if (mbarText) mbarText.textContent = K.fill(mbarText.getAttribute(count === 1 ? 'data-one' : 'data-many'), { packs: count, units: units });
    if (checkout) {
      if (count > 0) {
        checkout.setAttribute('href', checkout.getAttribute('data-href'));
        checkout.removeAttribute('aria-disabled');
      } else {
        checkout.removeAttribute('href');
        checkout.setAttribute('aria-disabled', 'true');
      }
    }
    if (mbar) mbar.classList.toggle('is-on', count > 0);
    pad();
  }

  el.addEventListener('click', function (event) {
    var target = event.target.closest('a, button');
    if (!target || !el.contains(target)) return;
    if (target.hasAttribute('data-kcb-open')) return K.openCart();
    if (target.hasAttribute('data-kcb-checkout')) {
      if (target.getAttribute('aria-disabled') === 'true') event.preventDefault();
      return;
    }
    if (target.hasAttribute('data-kcb-link')) {
      var node = targetOf(target);
      if (!node) return;
      event.preventDefault();
      place();
      pin(target);
      node.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', target.getAttribute('href'));
    }
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          links.forEach(function (link) {
            if (link.kcbTarget === entry.target) link.kcbSeen = entry.isIntersecting;
          });
        });
        mark();
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    var watched = [];
    links.forEach(function (link) {
      link.kcbTarget = targetOf(link);
      if (!link.kcbTarget || watched.indexOf(link.kcbTarget) > -1) return;
      watched.push(link.kcbTarget);
      observer.observe(link.kcbTarget);
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    queue();
    pad();
  });
  if (query && query.addEventListener) query.addEventListener('change', pad);

  K.on('cart', render);
  place();
  if (K.cart) render(K.cart);
});

KCB.register('hero-bundles', function (el, K) {
  el.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kcb-bundle]');
    if (!button || !el.contains(button) || button.disabled || button.kcbBusy) return;
    var items = [];
    try {
      items = JSON.parse(button.getAttribute('data-items') || '[]');
    } catch (e) {
      items = [];
    }
    if (!items.length) return;
    button.kcbBusy = true;
    K.add(items, el.getAttribute('data-error'))
      .then(function () {
        if (el.getAttribute('data-toast')) K.toast(el.getAttribute('data-toast'));
        K.flash([button], el.getAttribute('data-added-label'));
      })
      .catch(function () {})
      .then(function () {
        button.kcbBusy = false;
      });
  });
});

KCB.register('product-rows', function (el, K) {
  function num(node, name) {
    return Number(node.getAttribute(name)) || 0;
  }

  function clamp(value) {
    return Math.max(1, Math.min(99, parseInt(value, 10) || 1));
  }

  function select(row, opt) {
    K.$$('[data-kcb-opt]', row).forEach(function (o) {
      o.classList.toggle('is-on', o === opt);
      o.setAttribute('aria-pressed', o === opt ? 'true' : 'false');
    });
    var unit = num(opt, 'data-unit-price');
    var price = K.$('[data-kcb-unit]', row);
    if (price) price.textContent = K.money(unit);
    var earn = K.$('[data-kcb-earn]', row);
    if (earn) earn.textContent = K.fill(earn.getAttribute('data-template'), { amount: K.money(num(row, 'data-msrp') - unit) });
    var button = K.$('[data-kcb-add]', row);
    if (button) {
      var label = K.fill(el.getAttribute('data-add-label'), { pack: opt.getAttribute('data-label') });
      if (button.kcbLabel === undefined) button.textContent = label;
      else button.kcbLabel = label;
    }
  }

  function add(row, button) {
    var opt = K.$('[data-kcb-opt].is-on', row);
    var input = K.$('[data-kcb-qty]', row);
    if (!opt || row.kcbBusy) return;
    var qty = clamp(input ? input.value : 1);
    row.kcbBusy = true;
    K.add([{ id: num(opt, 'data-vid'), quantity: qty }], el.getAttribute('data-error'))
      .then(function () {
        var text = K.fill(el.getAttribute('data-toast'), { qty: qty, product: row.getAttribute('data-title'), pack: opt.getAttribute('data-label') });
        if (text) K.toast(text);
        K.flash([button], el.getAttribute('data-added-label'));
      })
      .catch(function () {})
      .then(function () {
        row.kcbBusy = false;
      });
  }

  el.addEventListener('click', function (event) {
    var target = event.target.closest('button');
    if (!target || !el.contains(target) || target.disabled) return;
    var row = target.closest('[data-kcb-row]');
    if (!row) return;
    if (target.hasAttribute('data-kcb-opt')) return select(row, target);
    if (target.hasAttribute('data-kcb-step')) {
      var input = K.$('[data-kcb-qty]', row);
      if (input && !input.disabled) input.value = clamp((parseInt(input.value, 10) || 1) + num(target, 'data-kcb-step'));
      return;
    }
    if (target.hasAttribute('data-kcb-add')) add(row, target);
  });

  el.addEventListener('change', function (event) {
    if (event.target.hasAttribute && event.target.hasAttribute('data-kcb-qty')) event.target.value = clamp(event.target.value);
  });
});

KCB.register('more-ways', function (el, K) {
  function num(node, name) {
    return Number(node.getAttribute(name)) || 0;
  }

  function picked(card) {
    return K.$('[data-kcb-pick]:checked', card);
  }

  function headline(card) {
    var node = K.$('[data-kcb-headline]', card);
    var input = picked(card);
    if (node && input) node.textContent = K.money(num(input, 'data-head'));
  }

  function add(card, button) {
    var input = picked(card);
    if (!input || input.disabled || card.kcbBusy) return;
    card.kcbBusy = true;
    K.add([{ id: num(input, 'data-vid'), quantity: 1 }], el.getAttribute('data-error'))
      .then(function () {
        var text = K.fill(el.getAttribute('data-toast'), {
          qty: 1,
          product: input.getAttribute('data-product'),
          label: input.getAttribute('data-label'),
          variant: input.getAttribute('data-variant'),
          card: card.getAttribute('data-title')
        });
        if (text) K.toast(text);
        K.flash([button], card.getAttribute('data-added-label'));
      })
      .catch(function () {})
      .then(function () {
        card.kcbBusy = false;
      });
  }

  el.addEventListener('change', function (event) {
    var input = event.target.closest('[data-kcb-pick]');
    if (input) headline(input.closest('[data-kcb-card]'));
  });

  el.addEventListener('click', function (event) {
    var button = event.target.closest('[data-kcb-add]');
    if (!button || !el.contains(button) || button.disabled) return;
    add(button.closest('[data-kcb-card]'), button);
  });

  K.$$('[data-kcb-card]', el).forEach(headline);
});

KCB.register('retail-math', function (el, K) {
  var packs = K.$$('[data-kcb-pack]', el).filter(function (p) {
    return !p.disabled;
  });
  var rack = K.$('[data-kcb-rack]', el);
  var caption = K.$('[data-kcb-caption]', el);
  var retailInput = K.$('[data-kcb-retail]', el);
  var weeklyInput = K.$('[data-kcb-weekly]', el);
  var addButton = K.$('[data-kcb-math-add]', el);
  if (!packs.length || !retailInput || !weeklyInput) return;

  var state = {
    pack:
      packs.filter(function (p) {
        return p.classList.contains('is-on');
      })[0] || packs[0],
    retail: 0,
    weekly: 1,
    busy: false
  };

  function num(node, name) {
    return Number(node.getAttribute(name)) || 0;
  }

  function text(sel, value) {
    var node = K.$(sel, el);
    if (node) node.textContent = value;
  }

  function whole(amount) {
    return K.money(amount * 100).replace(/[.,]00(?=\D*$)/, '');
  }

  function bottle(kind) {
    var node = document.createElement('div');
    node.className = 'kcb-math__btl' + (rack.getAttribute('data-bottle') === 'roller' ? ' kcb-math__btl--roller' : '') + ' ' + kind;
    var cap = document.createElement('span');
    cap.className = 'kcb-math__btl-cap';
    var neck = document.createElement('span');
    neck.className = 'kcb-math__btl-neck';
    var body = document.createElement('div');
    body.className = 'kcb-math__btl-body';
    var band = document.createElement('span');
    band.className = 'kcb-math__btl-band';
    body.appendChild(band);
    node.appendChild(cap);
    node.appendChild(neck);
    node.appendChild(body);
    return node;
  }

  function drawRack(n, cover) {
    if (!rack) return;
    var per = n <= 6 ? n : n <= 8 ? 4 : 6;
    rack.textContent = '';
    for (var i = 0; i < n; i += per) {
      var row = document.createElement('div');
      row.className = 'kcb-math__row';
      for (var k = i; k < Math.min(n, i + per); k += 1) row.appendChild(bottle(k < cover ? 'is-cover' : 'is-margin'));
      rack.appendChild(row);
    }
  }

  function bold(value) {
    var node = document.createElement('b');
    node.textContent = value;
    return node;
  }

  function drawCaption(values) {
    if (!caption) return;
    var chunks = String(el.getAttribute('data-caption') || '').split('[rest]');
    caption.textContent = '';
    chunks.forEach(function (chunk, index) {
      var start = chunk.indexOf('[cover]');
      var end = start < 0 ? -1 : chunk.indexOf('[n]', start);
      if (end < 0) {
        caption.appendChild(document.createTextNode(K.fill(chunk, values)));
      } else {
        caption.appendChild(document.createTextNode(K.fill(chunk.slice(0, start), values)));
        caption.appendChild(bold(K.fill(chunk.slice(start, end + 3), values)));
        caption.appendChild(document.createTextNode(K.fill(chunk.slice(end + 3), values)));
      }
      if (index < chunks.length - 1) caption.appendChild(bold(values.rest));
    });
  }

  function render() {
    var pack = state.pack;
    var n = Math.max(1, num(pack, 'data-units'));
    var cost = num(pack, 'data-price');
    var retail = state.retail;
    var weekly = state.weekly;
    var value = retail * n;
    var kept = value - cost;
    var cover = Math.min(n, Math.ceil(cost / retail));
    var weeks = n / weekly;
    var label = pack.getAttribute('data-label');
    var values = {
      cover: cover,
      n: n,
      rest: n - cover,
      noun: el.getAttribute('data-noun') || '',
      nouns: el.getAttribute('data-nouns') || '',
      margin: Math.round((kept / value) * 100),
      pack: label,
      price: K.money(cost)
    };

    packs.forEach(function (p) {
      p.classList.toggle('is-on', p === pack);
      p.setAttribute('aria-pressed', p === pack ? 'true' : 'false');
    });
    drawRack(n, cover);
    drawCaption(values);
    text('[data-kcb-retail-out]', K.money(retail));
    text('[data-kcb-weekly-out]', weekly);
    text('[data-kcb-keep]', K.money(kept / n));
    text('[data-kcb-keep-label]', K.fill(el.getAttribute('data-keep-label'), values));
    text('[data-kcb-stat="cost"]', K.money(cost));
    text('[data-kcb-stat="value"]', K.money(value));
    text('[data-kcb-stat="pack"]', K.money(kept));
    text('[data-kcb-stat="cover"]', K.fill(el.getAttribute('data-cover-value'), values));
    text('[data-kcb-stat="weeks"]', weeks >= 1 ? weeks.toFixed(1) : el.getAttribute('data-under-week') || '');
    text('[data-kcb-stat="month"]', whole(Math.round((kept * weekly * 433) / (n * 10000))));
    if (addButton && !addButton.classList.contains('is-added')) addButton.textContent = K.fill(el.getAttribute('data-add-label'), values);
    else if (addButton) addButton.kcbLabel = K.fill(el.getAttribute('data-add-label'), values);
  }

  function read() {
    state.retail = Math.max(1, Math.round((parseFloat(retailInput.value) || 0) * 100));
    state.weekly = Math.max(1, parseInt(weeklyInput.value, 10) || 1);
  }

  function byVariant(id) {
    return packs.filter(function (p) {
      return String(p.getAttribute('data-vid')) === String(id);
    })[0];
  }

  function buyBoxHas(id) {
    return !!document.querySelector('[data-kcb="buy-box"] [data-kcb-opt][data-vid="' + id + '"]:not([disabled])');
  }

  function add() {
    var pack = state.pack;
    var id = num(pack, 'data-vid');
    if (buyBoxHas(id)) return K.emit('select', { variant: id, keepImage: true, add: true, source: el });
    if (state.busy) return;
    state.busy = true;
    K.add([{ id: id, quantity: 1 }], el.getAttribute('data-error'))
      .then(function () {
        K.toast(K.fill(el.getAttribute('data-toast'), { product: el.getAttribute('data-product-title') || '', pack: pack.getAttribute('data-label') }));
        K.flash([addButton], el.getAttribute('data-added-label'));
      })
      .catch(function () {})
      .then(function () {
        state.busy = false;
      });
  }

  el.addEventListener('click', function (event) {
    var target = event.target.closest('button');
    if (!target || !el.contains(target) || target.disabled) return;
    if (target.hasAttribute('data-kcb-pack')) {
      state.pack = target;
      render();
      K.emit('select', { variant: num(target, 'data-vid'), keepImage: true, source: el });
      return;
    }
    if (target.hasAttribute('data-kcb-math-add')) add();
  });

  el.addEventListener('input', function (event) {
    if (event.target !== retailInput && event.target !== weeklyInput) return;
    read();
    render();
  });

  K.on('selected', function (detail) {
    if (!el.isConnected || detail.source === el || detail.group !== 'pack') return;
    var pack = byVariant(detail.variant);
    if (!pack) return;
    state.pack = pack;
    render();
  });

  read();
  render();
});

KCB.register('room-shelf', function (el, K) {
  var button = K.$('[data-kcb-backbar]', el);
  if (!button) return;
  if (!document.querySelector('[data-kcb="buy-box"] [data-kcb-opt][data-group="size"][data-vid]:not([disabled])')) {
    button.hidden = true;
    return;
  }
  button.addEventListener('click', function () {
    K.emit('select', { group: 'size', scroll: true, source: el });
  });
});

KCB.register('session-story', function (el, K) {
  var steps = K.$$('[data-kcb-step]', el);
  var slides = K.$$('[data-kcb-slide]', el);
  var dots = K.$$('[data-kcb-dot]', el);
  var cap = K.$('[data-kcb-cap]', el);
  var current = -1;

  function set(index) {
    if (index === current || !steps[index]) return;
    current = index;
    steps.forEach(function (step, i) {
      step.classList.toggle('is-on', i === index);
    });
    slides.forEach(function (slide) {
      slide.classList.toggle('is-on', Number(slide.getAttribute('data-kcb-slide')) === index);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-on', i === index);
    });
    if (cap) {
      var text = steps[index].getAttribute('data-cap') || '';
      cap.textContent = text;
      cap.hidden = !text;
    }
  }

  el.addEventListener('click', function (event) {
    var step = event.target.closest('[data-kcb-step]');
    if (!step || !el.contains(step) || event.target.closest('a, button')) return;
    set(steps.indexOf(step));
  });

  el.addEventListener('shopify:block:select', function (event) {
    var step = event.target.closest('[data-kcb-step]');
    if (step) set(steps.indexOf(step));
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) set(steps.indexOf(entry.target));
        });
      },
      { rootMargin: '-45% 0px -45% 0px' }
    );
    steps.forEach(function (step) {
      observer.observe(step);
    });
  }

  set(0);
});

KCB.register('formats', function (el, K) {
  var stands = K.$$('.kcb-shelf__stand[data-vid]', el);

  function mark(id) {
    var key = String(id || '');
    if (!key) return;
    var hit =
      stands.filter(function (stand) {
        return stand.getAttribute('data-vid') === key;
      })[0] ||
      stands.filter(function (stand) {
        return (',' + stand.getAttribute('data-vids') + ',').indexOf(',' + key + ',') > -1;
      })[0];
    if (!hit) return;
    stands.forEach(function (stand) {
      stand.classList.toggle('is-on', stand === hit);
      stand.setAttribute('aria-pressed', stand === hit ? 'true' : 'false');
    });
  }

  function choose(node) {
    var id = Number(node.getAttribute('data-vid'));
    var scroll = node.hasAttribute('data-kcb-scroll');
    mark(id);
    K.emit('select', { variant: id, scroll: scroll, preferDefault: node.hasAttribute('data-kcb-any'), source: el });
    if (!scroll) return;
    var box = document.querySelector('[data-kcb="buy-box"]');
    if (box && !box.querySelector('[data-kcb-opt][data-vid="' + id + '"]:not([disabled])')) {
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  el.addEventListener('click', function (event) {
    var node = event.target.closest('[data-kcb-choose]');
    if (node && el.contains(node)) choose(node);
  });

  el.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target.matches('.kcb-shelf__stand[data-kcb-choose]')) return;
    event.preventDefault();
    choose(event.target);
  });

  K.on('selected', function (detail) {
    mark(detail.variant);
  });

  K.on('select', function (detail) {
    if (detail.source !== el) mark(detail.variant);
  });

  var box = document.querySelector('[data-kcb="buy-box"]');
  if (box) mark(box.getAttribute('data-default'));
});

KCB.register('calculator', function (el, K) {
  var sess = K.$('[data-kcb-sess]', el);
  var ml = K.$('[data-kcb-ml]', el);
  if (!sess || !ml) return;
  var sizes = K.$$('[data-kcb-size]', el);
  var addButton = K.$('[data-kcb-calc-add]', el);
  var current = null;
  var busy = false;

  function num(node, name) {
    return Number(node.getAttribute(name)) || 0;
  }

  function put(sel, text) {
    var node = K.$(sel, el);
    if (node) node.textContent = text;
  }

  function buyOption(id) {
    var box = document.querySelector('[data-kcb="buy-box"]');
    return box ? box.querySelector('[data-kcb-opt][data-vid="' + id + '"]:not([disabled])') : null;
  }

  function render() {
    var sessions = Math.max(1, Number(sess.value) || 1);
    var amount = Math.max(1, Number(ml.value) || 1);
    put('[data-kcb-out-sess]', sessions);
    put('[data-kcb-out-ml]', amount + ' ' + (el.getAttribute('data-unit') || ''));
    if (!current) return;
    var price = num(current, 'data-price');
    var volume = parseFloat(current.getAttribute('data-volume')) || 0;
    var per = Math.max(1, Math.round(volume / amount));
    var cps = price / 100 / per;
    var weeks = per / sessions;
    var monthly = Math.round(cps * sessions * 4.33);
    put('[data-kcb-cps]', K.money(cps * 100));
    put('[data-kcb-per]', per);
    put('[data-kcb-weeks]', weeks >= 1 ? weeks.toFixed(1) : el.getAttribute('data-under-one') || '');
    put('[data-kcb-monthly]', K.money(monthly * 100).replace(/[.,]00(?!\d)/, ''));
    if (addButton) {
      var text = K.fill(el.getAttribute('data-add-label'), { size: current.getAttribute('data-label'), price: K.money(price) });
      if (addButton.kcbLabel !== undefined) addButton.kcbLabel = text;
      else addButton.textContent = text;
    }
  }

  function pick(button) {
    if (!button) return;
    current = button;
    sizes.forEach(function (size) {
      size.classList.toggle('is-on', size === button);
      size.setAttribute('aria-pressed', size === button ? 'true' : 'false');
    });
    render();
  }

  function byVariant(id) {
    return sizes.filter(function (size) {
      return size.getAttribute('data-vid') === String(id);
    })[0];
  }

  function add() {
    if (!current || busy) return;
    var id = num(current, 'data-vid');
    if (buyOption(id)) {
      K.emit('select', { variant: id, keepImage: true, add: true, source: el });
      return;
    }
    var label = current.getAttribute('data-label');
    busy = true;
    K.add([{ id: id, quantity: 1 }], el.getAttribute('data-error'))
      .then(function () {
        K.toast(K.fill(el.getAttribute('data-toast'), { product: el.getAttribute('data-product-title'), size: label }));
        K.flash([addButton], el.getAttribute('data-added-label'));
      })
      .catch(function () {})
      .then(function () {
        busy = false;
      });
  }

  el.addEventListener('click', function (event) {
    var target = event.target.closest('button');
    if (!target || !el.contains(target)) return;
    if (target.hasAttribute('data-kcb-size')) {
      pick(target);
      K.emit('select', { variant: num(target, 'data-vid'), keepImage: true, source: el });
      return;
    }
    if (target === addButton) add();
  });

  el.addEventListener('input', function (event) {
    if (event.target === sess || event.target === ml) render();
  });

  K.on('selected', function (detail) {
    if (detail.group === 'size') pick(byVariant(detail.variant));
  });

  K.on('select', function (detail) {
    if (detail.source !== el && detail.variant) pick(byVariant(detail.variant));
  });

  var box = document.querySelector('[data-kcb="buy-box"]');
  pick(byVariant(box ? box.getAttribute('data-default') : '') || sizes[0]);
  render();
});

KCB.register('label-anatomy', function (el, K) {
  var pins = K.$$('[data-kcb-pin]', el);
  var cards = K.$$('[data-kcb-pin-card]', el);

  function set(index) {
    if (index < 0 || !cards[index]) return;
    pins.forEach(function (pin, i) {
      pin.classList.toggle('is-on', i === index);
      pin.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
    cards.forEach(function (card, i) {
      card.classList.toggle('is-on', i === index);
    });
  }

  function find(event) {
    var node = event.target.closest('[data-kcb-pin], [data-kcb-pin-card]');
    if (!node || !el.contains(node)) return -1;
    return Number(node.getAttribute('data-kcb-pin') || node.getAttribute('data-kcb-pin-card'));
  }

  ['click', 'mouseover', 'focusin', 'shopify:block:select'].forEach(function (name) {
    el.addEventListener(name, function (event) {
      set(find(event));
    });
  });

  set(0);
});

(function () {
  var K = window.KCB;
  if (!K || K.booted) return;
  K.booted = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', K.boot);
  else K.boot();
})();
